import React from 'react';
import { Link } from '@reach/router';
import Helmet from 'react-helmet';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import kismetInstagram from '../../assets/img/instagram/kismetSunset@fiferries.jpg';

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Kismet"
      meta={[
        {
          name: 'description',
          content:
            'Fire Island Ferries updates, service notifications, and new schedules.',
        },
        {
          name: 'keywords',
          content: 'Fire Island Ferries, Water Taxi, notifications, updates',
        },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader beach="Kismet">
        <h2>Communities</h2>
        <h1>Kismet</h1>
        <p>Amenities</p>
        <div className="amenities">
          {Amenities.byBeach('Kismet').map(item => (
            <i
              key={item.text}
              className={`icon-${item.icon}`}
              title={item.text}
            />
          ))}
        </div>
        <div>
          <Link className="btn btn-outline-light" to="/schedules/kismet">
            Schedules
          </Link>
          &nbsp;&nbsp;
          <Link className="btn btn-outline-light" to="/directory">
            Directory
          </Link>
        </div>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h1>About Kismet</h1>
          </div>
          <p>
            Kismet is the westernmost community on Fire Island and closest to
            the Fire Island Lighthouse. Visitors find that many Kismet residents
            are quick with a greeting and a smile as they pass on the street.
            This family friendly community provides locals and beach-goers with
            two full-service restaurants, The Kismet Inn and Surf’s Out, a pizza
            shack, a marina, a liquor store and cheese shop, the family owned
            Kismet Market, and a gift shop, the Red Wagon Emporium. In addition
            to restaurants and shops, there are public tennis and basketball
            courts, as well as newly renovated playground completed in 2017.
          </p>
        </div>
        <div className="col-xl-4">
          <Instagram
            account="fiferries"
            datestamp="June 23, 2016"
            profile={fiferries}
            image={kismetInstagram}
            link="https://www.instagram.com/p/BG_cmLcGpuy/?taken-by=fiferries"
            className="mx-auto"
          />
        </div>
      </div>
      <Tip title="Captain's Tip">
        Be sure to check out a sunset from the ferry dock with both the Robert
        Moses Bridge and the Fire Island Lighthouse in the foreground.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Kismet is available by Fire Island Ferries
        from Bay Shore.{' '}
        <Link to="/schedules/kismet">Click here for schedules.</Link>
      </p>
      <p>
        <a href="http://www.fireislandwatertaxi.com">Water Taxi</a> service is
        available to and from Kismet during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
